import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
} from 'ramda';
import fields from './fields';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import Select from '../../common/Select';
import CustomPieChart from '../../common/CustomPieChart';
import Breadcrumbs from '../../common/Breadcrumbs';
import { getJobCards } from '../../api/jobCards';
import { getList } from '../../api/projects';
import { fetchAllData as getBoardStages } from '../../api/boardSettings';
import { processFields } from '../../utils/prePost';
import { getChart } from '../../api/analytics';

export class Analytics extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: fields,
    };
    this.changeFormValue = this.changeFormValue.bind(this);
    this.getJobCardsList = this.getJobCardsList.bind(this);
    this.parseCustomersList = this.parseCustomersList.bind(this);
    this.fetchChart = this.fetchChart.bind(this);
  }

  componentWillMount() {
    this.props.jobCardsList();
    this.props.projectsList();
    this.props.stageList();
    this.fetchChart(this.state);
  }

  fetchChart(data) {
    const pData = processFields(data.fields);
    this.props.getChartData(pData);
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    const newState = mergeDeepLeft(stateClone, this.state);
    this.setState(newState);
    this.fetchChart(newState);
  }

  getProjectsList() {
    return this.parseCustomersList(path(['projects', 'list'], this.props));
  }

  parseCustomersList(arr) {
    const arrCustomers = [{
      value: 0,
      text: 'All',
    }];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          text: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  getJobCardsList() {
    const jobCardsSource = path(['jobCards', 'list'], this.props) || [];
    const jobCardsList = [{
      value: 0,
      text: 'All',
    }];

    for (let i = 0; i < jobCardsSource.length; i++) {
      jobCardsList.push({
        value: jobCardsSource[i].job_card_color_id,
        text: jobCardsSource[i].label,
      })
    }
    return jobCardsList;
  }

  getStagesList() {
    const stagesSource = path(['boardSettings', 'stages'], this.props) || [];
    const stagesList = [{
      value: 0,
      text: 'All',
    }];

    for (let i = 0; i < stagesSource.length; i++) {
      stagesList.push({
        value: stagesSource[i].id,
        text: stagesSource[i].label,
      })
    }
    return stagesList;
  }

  render() {
    const chartData = path(['analytic', 'list'], this.props) || [];
    return (
      <div>
        <Breadcrumbs list={[
         { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
         { icon: 'track_changes', name: 'Analytics' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            Analytics
          </div>
          <div className="card-block row">
            <div className="col col-md-5 col-lg-5">
              <Select
                field={this.state.fields['breakdown']}
                onChange={this.changeFormValue}
              />
              <Select
                options={this.getJobCardsList()}
                field={this.state.fields['card_type']}
                onChange={this.changeFormValue}
              />
              <Select
                options={this.getStagesList()}
                field={this.state.fields['in_stage']}
                onChange={this.changeFormValue}
              />
              <Select
                options={this.getProjectsList()}
                field={this.state.fields['in_project']}
                onChange={this.changeFormValue}
              />
            </div>
            <div className="col col-md-7 col-lg-7">
              <CustomPieChart
                data={chartData}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    jobCardsList: () => {
      getJobCards()(dispatch);
    },
    projectsList: () => {
      getList()(dispatch);
    },
    stageList: () => {
      getBoardStages()(dispatch);
    },
    getChartData: (data) => {
      if (!data.breakdown) {
        data.breakdown = 1;
      }

      const reqData = {
        filters: JSON.stringify(data),
      };
      getChart(reqData)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);



// WEBPACK FOOTER //
// ./src/containers/Analytics/index.js